import axios from "axios";

import firebase, { database } from "../../config/firebase";

const API_KEY = process.env.REACT_APP_BACKEND_URL;

export const authenticate = () => dispatch => {
  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      let dbUser = {};
      database
        .ref()
        .child("users")
        .child(user.uid)
        .on("value", snapshot => {
          dbUser = snapshot.val() || {};
        });

      user.getIdTokenResult(true).then(idTokenResult => {
        const coolUser = { ...user, ...idTokenResult.claims, ...dbUser };
        console.log("coolUser", coolUser);
        dispatch({
          type: "AUTHENTICATED",
          payload: coolUser
        });
      });
    }
  });
};

// TODO: Change name to something more descriptive of the actual behaviour
export const getAuthTokenAndSignIn = values => (dispatch, getState) => {
  database
    .ref()
    .child("users")
    .orderByChild("password")
    .equalTo(values.password)
    .on("value", snapshot => {
      if (snapshot.val() === null) return;
      const user = Object.values(snapshot.val())[0] || {};
      const userId = user.key;

      if (!user.professor) {
        axios
          .post(`${API_KEY}/auth/signIn`, {
            login: {
              uid: userId,
              nivel: user.nivel,
              identificadorNivel: user.identificadorNivel,
              nombre: user.nombre,
              groupKey: user.groupKey,
              colegio: user.colegio
            }
          })
          .then(res => {
            firebase
              .auth()
              .signInWithCustomToken(res.data.token)
              .catch(function(error) {
                console.log(error);
              })
              .then(x => {});
          });
      } else {
        console.log("hay un problema amiguito");
      }
    });
};

// TODO: Could unify this and student's login into one
export const getAuthTokenAndSignInProfessor = values => dispatch => {
  database
    .ref()
    .child("users")
    .orderByChild("password")
    .equalTo(values.password)
    .on("value", snapshot => {
      if (snapshot.val() === null) return;
      const user = Object.values(snapshot.val())[0] || {};
      const userId = user.key;

      if (user.professor) {
        axios
          .post(`${API_KEY}/auth/signInProfessor`, {
            login: {
              uid: userId,
              professor: user.professor,
              colegio: user.colegio
            }
          })
          .then(res => {
            console.log(res.data.token);
            firebase
              .auth()
              .signInWithCustomToken(res.data.token)
              .catch(function(error) {})
              .then(x => {
                dispatch(authenticate());
              });
          });
      } else {
        console.log("Hay un problemo porque no es un profesor");
      }
    });
};

export const signInWithGoogleProvider = () => dispatch => {
  const provider = new firebase.auth.GoogleAuthProvider();
  firebase
    .auth()
    .signInWithPopup(provider)
    .then(result => {
      return result.user.getIdToken();
    })
    .then(idToken => {
      axios.post(`${API_KEY}/auth/setAdminCustomClaims`, {
        idToken
      });
    });
};

export const logout = () => dispatch => {
  firebase
    .auth()
    .signOut()
    .then(function() {
      dispatch({ type: "LOGOUT" });
    })
    .catch(function(error) {});
};
